// Accessible and simplified footer for Volto
// Contains only Impressum, Barrierefreiheit, Datenschutz, and Powered by Plone.

import React from 'react';
import { Container, List, Segment } from 'semantic-ui-react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import ukdLogo from './UKD SIGNET_2zeilig_weiss.png';

/*
  This version drops the dynamic siteActions and focuses on a minimal, more
  accessible structure. ARIA roles are simplified, link labels are explicit,
  and the markup avoids redundant wrappers.
*/

const Footer = () => {
  return (
    <>
      <Segment
        as="footer"
        role="contentinfo"
        vertical
        padded
        inverted
        textAlign="center"
        id="footer"
        aria-label="Website footer"
      >
        <Container>
          {/* Static accessible link list */}
          <List as="nav" aria-label="Footer navigation" horizontal inverted>
            <List.Item>
              <UniversalLink href="/impressum">Impressum</UniversalLink>
            </List.Item>
            <List.Item>
              <UniversalLink href="/barrierefreiheit">
                Barrierefreiheit
              </UniversalLink>
            </List.Item>
            <List.Item>
              <UniversalLink href="/datenschutz">Datenschutz</UniversalLink>
            </List.Item>
            <List.Item>
              <UniversalLink href="/login">Login</UniversalLink>
            </List.Item>
          </List>
          <div className="footer-logo-ukd">
            <img src={ukdLogo} alt="UKD Logo Footer" />
          </div>
        </Container>
      </Segment>
    </>
  );
};

export default Footer;
